
import { Theme } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import classNames from 'clsx';
import { CommonPropsAndTypes } from '../_Types/StandardComponentProps';

interface IProps {
  paddingBottom?: CommonPropsAndTypes.StandardSpacingType;
  classes?: any;
}

const styles = (theme: Theme) => ({
  item: {
    width: '100%',
    display: 'block',
    breakInside: 'avoid',
  },
  paddingBottom: {
    paddingBottom: theme.spacing(2),
    '&:last-child': {
      paddingBottom: '2px',
    },
  },
  paddingBottomDense: {
    paddingBottom: '2px',
  },
});

const EDMasonryItem: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  return (
    <span
      className={classNames(props.classes.item, {
        [props.classes.paddingBottom]: props.paddingBottom === 'normal',
        [props.classes.paddingBottomDense]: props.paddingBottom === 'dense',
      })}
    >
      {props.children}
    </span>
  );
};

export default withStyles(EDMasonryItem, styles);
